export enum ProjectPhase {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  IN_DESIGN = 'IN_DESIGN',
  IN_BUILD = 'IN_BUILD',
  IN_DOCUMENTATION = 'IN_DOCUMENTATION',
}

export interface ProjectDepartment {
  kstId: number;
  displayName: string;
}

export interface ProjectDTO {
  contractNr: string;
  displayName: string;
  phase: ProjectPhase;
  department: ProjectDepartment;
}

export interface Project {
  contractNr: string;
  displayName: string;
  phase: ProjectPhase;
  department: ProjectDepartment;
}

/** Payload für POST /project */
export interface ProjectStub {
  contractNr: string;
  displayName: string;
  phase: ProjectPhase;
  department: { kstId: number };
}

